var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferendaSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_5145_24902)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5147 27.0002L20.364 27.8494C20.7545 28.24 21.3876 28.24 21.7782 27.8494L22.6274 27.0002M19.5147 27.0002L15.1174 22.6029C14.7269 22.2124 14.7269 21.5792 15.1174 21.1887L23.3691 12.9369C23.7596 12.5464 24.3928 12.5464 24.7833 12.9369L30.0299 18.1835C30.4204 18.574 30.4204 19.2072 30.0299 19.5977L22.6274 27.0002M19.5147 27.0002H16.4142C16.149 27.0002 15.8946 27.1056 15.7071 27.2931L12 31.0002H32L28.2929 27.2931C28.1054 27.1056 27.851 27.0002 27.5858 27.0002H22.6274M19.618 20.6227L21.618 22.6227L25.618 18.6227",
    stroke: "#1B202C",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5145_24902",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B202C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B202C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferendaSquare);
export default __webpack_public_path__ + "static/media/referenda-square.ff2a67a3126fb6e2c20f10be03092657.svg";
export { ForwardRef as ReactComponent };